import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  ChangeEvent
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store';
import {
  applyPromocode,
  selectAppliedStatus,
  selectLoading,
  selectPromocode
} from '../../../../store/promocode';

export const usePromocode = () => {
  const dispatch: AppDispatch = useDispatch();
  const promocodeStore = useSelector(selectPromocode);
  const loading = useSelector(selectLoading);
  const appliedStatus = useSelector(selectAppliedStatus);

  const [hasError, setHasError] = useState(false);
  const [promocode, setPromocode] =
    useState(promocodeStore);

  const disabled = useMemo(
    () => !promocode || promocodeStore === promocode,
    [promocode, promocodeStore]
  );

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      setPromocode(value);
      setHasError(false);
    },
    []
  );

  const onSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      dispatch(applyPromocode(promocode));
    },
    [promocode, dispatch]
  );

  useEffect(() => {
    if (
      appliedStatus === 'failed' ||
      loading === 'failed'
    ) {
      setHasError(true);
    }
  }, [appliedStatus, loading]);

  useEffect(() => {
    setPromocode(promocodeStore);
  }, [promocodeStore]);

  return {
    promocode,
    disabled,
    hasError,
    onChange,
    onSubmit
  };
};
